import {
  ErrorType,
  IErrorNormalizer,
  IResponseError,
  VmafError,
} from './types';

function getErrorType(error: IResponseError) {
  const response = error.response;

  if (!response) {
    return;
  }

  if (response.status === 401) {
    return ErrorType.UNAUTHORIZED;
  }

  // TODO: review when adi handle unauthorised requests correctly https://github.com/wix-private/adi-mobile/issues/41
  if (response.status === 500) {
    const detailsMessage =
      response.data && response.data.details && response.data.details.message;

    if (
      detailsMessage &&
      detailsMessage.startsWith("message: 'Session not found'")
    ) {
      return ErrorType.UNAUTHORIZED;
    }
  }
}

class AdiSiteErrorNormalizer implements IErrorNormalizer {
  normalizeToVmafError(error: IResponseError): VmafError {
    return new VmafError(
      error.message,
      getErrorType(error) || ErrorType.SITE_UNKNOWN,
      error,
    );
  }
}

export default AdiSiteErrorNormalizer;
